module.exports = __webpack_public_path__ + "img/bdlogo.c20ab29e.png";